// extracted by mini-css-extract-plugin
export default {"aaaa":"App_aaaa__qVjKn"};